import { useState, useCallback } from "react";

export default function useListbox(length: number, callback?: () => void) {
	const [currentActive, setCurrentActive] = useState<number>(-1);

	const handleKeyDown = useCallback(
		(evt: React.KeyboardEvent) => {
			if (
				evt.keyCode === 38 ||
				evt.keyCode === 40 ||
				evt.keyCode === 32
			) {
				evt.preventDefault();
			}
			switch (evt.keyCode) {
				case 32:
					if (callback) {
						callback();
					}
					break;
				case 36:
					setCurrentActive(0);
					break;
				case 35:
					setCurrentActive(length - 1);
					break;
				case 40:
					setCurrentActive(
						currentActive === length - 1
							? length - 1
							: currentActive + 1
					);
					break;
				case 38:
					setCurrentActive(
						currentActive === 0 ? 0 : currentActive - 1
					);
					break;
				default:
					break;
			}
		},
		[length, currentActive, setCurrentActive, callback]
	);
	return { currentActive, setCurrentActive, handleKeyDown };
}
